export default __webpack_public_path__ + "static/media/team-call.bfee2c44.mp3";